import './plugins/quasar'

import Vue from 'vue'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import i18n from './plugins/i18n'
import store from './store'

// Plugins

if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID) {
  Vue.use(VueGtag, {
    config: {
      id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID
    }
  })
}

Vue.config.productionTip = false

new Vue({
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
